import type { ReactNode } from 'react';
import React from 'react';
import Link from '@wix/thunderbolt-elements/src/components/Link/viewer/Link';
import type { LinkProps } from '@wix/thunderbolt-elements/src/components/Link/Link.types';

export type MenuButtonLinkProps = {
  wrapperProps: {
    positionInList?: string;
    ariaHasPopup?: 'false' | 'true';
    ariaDescribedBy?: string;
    ariaCurrent?: 'page';
    ariaExpanded?: boolean | 'false' | 'true';
    isMoreButton?: boolean;
    role?: string;
  };
  className?: string;
  compClassName?: string;
  children: ReactNode;
  link?: LinkProps;
  tabIndex?: number;
};

const MenuButtonLink: React.FC<MenuButtonLinkProps> = ({
  wrapperProps: {
    ariaHasPopup,
    isMoreButton,
    ariaDescribedBy,
    ariaExpanded,
    ariaCurrent,
    role,
  },
  className,
  children,
  link,
  tabIndex,
}) => {
  const _getTabIndex = () => {
    return tabIndex || (isMoreButton || !link || !link.href ? 0 : undefined);
  };
  return (
    <Link
      {...link}
      aria-haspopup={ariaHasPopup}
      aria-describedby={ariaDescribedBy}
      aria-current={ariaCurrent}
      aria-expanded={ariaExpanded}
      tabIndex={_getTabIndex()}
      className={className}
      role={role}
    >
      {children}
    </Link>
  );
};

export default MenuButtonLink;
